import { render, staticRenderFns } from "./ComplementaryImages.vue?vue&type=template&id=1acf6268&"
import script from "./ComplementaryImages.vue?vue&type=script&lang=js&"
export * from "./ComplementaryImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports